import React, { useState } from 'react'
import PropTypes from 'prop-types'
import 'styles/EditDeviceModal.css'
import { useTranslation } from 'react-i18next'
import { getOnChangeFunction } from 'utils'

const EditDeviceModal = ({ device, groups = [], onClose, onSave }) => {
  const { t } = useTranslation()
  const [localDevice, setLocalDevice] = useState({ ...device })
  const onChange = getOnChangeFunction(setLocalDevice, localDevice)

  return (
    <div className='edit-device-modal-overlay'>
      <div className='edit-device-modal'>
        <h2>{t('mgmt.editDevice.title')}</h2>

        <div className='device-details-section'>
          <h3>{t('mgmt.editDevice.details')}</h3>

          <label className='flex flex-col gap-1 text-sm font-medium text-gray-700 mb-3'>
            {t('mgmt.editDevice.deviceGroup')}
            <select
              name='deviceGroupId'
              value={localDevice.deviceGroupId || ''}
              onChange={onChange}
              className='p-2 border rounded-md shadow-sm bg-white font-normal w-full'
            >
              <option value=''>{t('mgmt.editDevice.noGroup')}</option>
              {groups.map(group => (
                <option key={group.value} value={group.value}>{group.label}</option>
              ))}
            </select>
          </label>

          <div className='manager-checkbox'>
            <label>
              <input
                type='checkbox'
                name='managerDevice'
                checked={localDevice.managerDevice}
                onChange={onChange}
              />
              {t('mgmt.editDevice.managerDevice')}
            </label>
          </div>
        </div>

        <div className='modal-actions'>
          <button type='button' className='cancel-button' onClick={onClose}>
            {t('mgmt.common.cancel')}
          </button>
          <button type='button' className='save-button' onClick={() => onSave(localDevice)}>
            {t('mgmt.common.save')}
          </button>
        </div>
      </div>
    </div>
  )
}

EditDeviceModal.propTypes = {
  device: PropTypes.object.isRequired,
  groups: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })),
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired
}

export default EditDeviceModal
